import React from "react"; //check without
import * as types from "./actionTypes";
import { getLayout } from "../store/configureStore";
import * as DomainConstants from '../constants/DomainConstants';
import * as ComponentConstants from "../constants/ComponentConstants";

export function layoutUpdated(layout) {
	return {
		type: types.LAYOUT_UPDATED,
		body: layout
	};
}

export function loadDemoPageLayout(pageTitle, isNew, modelId) {
	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.showHeader = !isNew;
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadTestPageLayout() {
	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.showHeader = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadExceptionPageLayout() {
	return function (dispatch) {

		let layout = getDefaultLayout();
		layout.showHeader = false;
		layout.pageHeaderTitle = "";
		layout.pageHeaderSubtitle = "";
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadDefaultLayout() {
	return function (dispatch) {
		return dispatch(layoutUpdated(getDefaultLayout()));
	};
}

export function loadDetailPageLayout(title, subtitle) {
	return function (dispatch) {

		let layout = getDefaultLayout();
		layout.showHeader = false;
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = subtitle;
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function resetTopNavTabSettings(layout) {
	layout.topNavTabsSet = false;
	layout.topNavTabSettings = [];
}

function getDefaultLayout() {
	let layout = getLayout();

	layout.scope = DomainConstants.DomainScopes.DEFAULT;
	layout.showHeader = false;
	layout.pageHeaderTitle = "";
	layout.pageHeaderSubtitle = "";
	layout.showTopNav = true;
	layout.showSideNav = false;
	layout.showBeads = false;

	return layout;
}
